import {
  CapabilitiesTile,
  ComponentSelector,
  Hero,
  HeroFlattenImage,
  HomeDecorCard,
  Image,
  LoyaltyBenefits,
  OnlineWorkshops,
  PersonalizedHomeServices,
  PopularCategories,
  PrivateLabelCreditCard,
  PromotionCard,
  RecentOrders,
  RecentPurchases,
  Recommendations,
  SectionSelector,
  ShopByCategory,
  SignIn,
  StoreDetails,
  SpecialBuyOfTheDay,
  SpecialBuyOfTheWeek,
  SponsoredBanner,
  Spotlight,
  UserList,
  VisualNavigation,
  WelcomeMessage,
} from '.';

export const components = {
  CapabilitiesTile,
  ComponentSelector,
  Hero,
  HeroFlattenImage,
  HomeDecorCard,
  Image,
  LoyaltyBenefits,
  OnlineWorkshops,
  PersonalizedHomeServices,
  PopularCategories,
  PrivateLabelCreditCard,
  PromotionCard,
  RecentOrders,
  RecentPurchases,
  Recommendations,
  Section: SectionSelector,
  ShopByCategory,
  SignIn,
  StoreDetails,
  SpecialBuyOfTheDay,
  SpecialBuyOfTheWeek,
  SponsoredBanner,
  Spotlight,
  UserList,
  VisualNavigation,
  welcomeMessage: WelcomeMessage,
};
